<template>
  <div
    class="divider"
    :class="{
      'horizontal-line': hasLine && !vertical,
      'vertical-line': hasLine && vertical
    }"
    :style="{
      height: vertical ? '100%' : `${dividerSize}px`,
      width: !vertical ? '100%' : `${dividerSize}px`
    }"
  />
</template>

<script>
export default {
  name: 'divider',
  props: {
    dividerSize: {
      type: String,
      default: '24'
    },
    hasLine: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.horizontal-line {
  border-bottom: 1px solid $black-20;
}
.vertical-line {
  border-left: 1px solid $black-20;
}
</style>
